import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

const AltLayout = () => {
  return (
    <Box data-testid="Box-8vox"
      sx={{
        width: '100%',
        height: '100dvh',
        overflowY: 'auto',
        overflowX: 'hidden',
      }}
    >
      <Outlet />
    </Box>
  );
};

export default AltLayout;
